<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col sm="6" lg="6">
        <b-card no-body class="bg-info">
          <b-card-body>
            <h4
              v-if="!areThereFilters"
              class="mb-0"
            >
              {{ usersInSystem ? usersInSystem.toLocaleString() : 0 }}
            </h4>
            <h4
              v-else
              class="mb-0"
            >
              {{ totalRows }} of {{ usersInSystem ? usersInSystem.toLocaleString() : 0 }}
            </h4>
            <p>User Records</p>
            <p>{{activeUserLength}} ACTIVE USERS</p>
            <b-button variant="primary" @click="addUser">Add New User</b-button>
            <b-button
              v-if="isSuperAdmin && !isDeactivateUsersModeOn"
              variant="primary"
              class="ml-2"
              @click="toggleDeactiveUsersModeOn"
            >
              Deactivate Users
            </b-button>
          </b-card-body>
        </b-card>
      </b-col>
      <b-col sm="6" lg="6">
        <b-card no-body class="bg-info">
          <b-card-body>
            <h4 class="mb-0">Search</h4>
            <p>By Name, Email or Primary Organization</p>
            <b-input-group>
              <b-form-input v-model="filter.nameText" @input="handleFilterChange" placeholder="Type to Search" />
              <b-input-group-addon>
                <b-btn :disabled="!filter.nameText" @click="clearFilter">Clear</b-btn>
              </b-input-group-addon>
            </b-input-group>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>

    <b-row>
      <b-col sm="12">
        <div>
          <b-btn v-b-toggle.collapse1 variant="primary">Filters</b-btn>
          <b-btn
          v-on:click.prevent="resetFilters">Clear Filters</b-btn>

          <b-collapse id="collapse1" class="mt-2">
            <b-card>
              <b-row>
                <b-col sm="2">
                  <b-form-group label="CSE-IT Trained">
                    <b-form-select class="mb-2 mr-sm-2 mb-sm-0"
                      v-model="isCseitTrained"
                      :style="{ width: '150px' }">
                      <option slot="first" :value="null">Choose...</option>
                      <option value="true">Yes</option>
                      <option value="false">No</option>
                    </b-form-select>
                  </b-form-group>
                </b-col>
                <b-col sm="2">
                  <b-form-group label="Is Active">
                    <b-form-select class="mb-2 mr-sm-2 mb-sm-0"
                      v-model="isActive"
                      :style="{ width: '150px' }">
                      <option slot="first" :value="null">Choose...</option>
                      <option value="true">true</option>
                      <option value="false">false</option>
                      <option value="deactivated">deactivated</option>
                    </b-form-select>
                  </b-form-group>
                </b-col>
                <b-col sm="2">
                  <b-form-group label="Role">
                    <b-form-select class="mb-2 mr-sm-2 mb-sm-0"
                      v-model="userRole"
                      :style="{ width: '150px' }">
                      <option slot="first" :value="null">Choose...</option>
                      <option value="user">User</option>
                      <option value="manager">Manager</option>
                      <option value="admin">Admin</option>
                    </b-form-select>
                  </b-form-group>
                </b-col>
                <b-col sm="2">
                  <b-form-group label="State">
                    <b-form-select class="mb-2 mr-sm-2 mb-sm-0"
                      v-model="userState"
                      :style="{ width: '150px' }"
                      :options="stateOptions"
                    >
                      <option slot="first" :value="null">Choose...</option>
                    </b-form-select>
                  </b-form-group>
                </b-col>
                <b-col sm="2">
                  <b-form-group label="Primary Organization">
                    <b-form-select class="mb-2 mr-sm-2 mb-sm-0"
                      v-model="primaryOrg"
                      :style="{ width: '150px' }"
                      :options="organizationOptions"
                    >
                      <option slot="first" :value="null">Choose...</option>
                    </b-form-select>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-button
                v-on:click.prevent="updateSearchResults"
                type="submit"
                variant="primary"
                class="px-4"
              >
                Update Results
              </b-button>
            </b-card>
          </b-collapse>
        </div>
      </b-col>
    </b-row>
    <br>

    <b-row>
      <b-col sm="12">
        <b-card>
          <h2 v-show="!finishedLoading" class="u-padding-bottom-20">Loading, please wait ...</h2>
          <pulse-loader :loading="!finishedLoading" :color="spinnerColor" :size="spinnerSize"></pulse-loader>
          <b-table
              ref="usersTable"
              :key="tableKey"
              v-show="finishedLoading"
              :filter="filter"
              :filter-function="searchFilter"
              :sort-by.sync="sortBy"
              :sort-desc.sync="sortDesc"
              :sort-direction="sortDirection"
              @filtered="onFiltered"
              :hover="true"
              :striped="true"
              :bordered="false"
              :small="true"
              :fixed="true"
              responsive="sm"
              :items="tableItems"
              :fields="tableFields"
              :per-page="20"
              :current-page="currentPage">
              <div slot="isSelectedToDeactivate" class="" slot-scope="data">
                <b-form-checkbox
                  class="users-table__checkbox"
                  v-model="data.item.isSelectedToDeactivate"
                  :disabled="data.item.isRemoved"
                />
              </div>
              <div slot="fullName" class="" slot-scope="data">
                <b-link @click="goUser(data.item.id)"><span class="">{{data.value}}</span></b-link>
              </div>
              <div slot="primaryOrganization" slot-scope="data">
                <span>{{ data.item.isRemoved ? '' : data.value.title }}</span>
              </div>
              <div slot="role" slot-scope="data">
                <span class="">{{getUserRole(data.item, true)}}</span>
              </div>
          </b-table>
          <div class="users-table__footer">
            <b-pagination :total-rows="getRowCount(tableItems)" prev-text="Prev" next-text="Next" :current-page="currentPage" v-model="currentPage"></b-pagination>
            <div v-if="isSuperAdmin && isDeactivateUsersModeOn">
              <b-button variant="secondary" @click="cancelDeactivateUserSelection">
                Cancel
              </b-button>
              <b-button variant="danger" class="ml-2" :disabled="!usersToDeactivate.length" @click="showDeactivateUsersModal">
                Submit
              </b-button>
            </div>
          </div>
        </b-card>
      </b-col>
    </b-row>
    <b-modal
      v-model="isDeactivateUsersModalVisible"
      title="Deactivate Users"
      size="lg"
      ok-title="Confirm Deactivation"
      cancel-title="Cancel"
      header-bg-variant="success"
      header-text-variant="light"
      ok-variant="success"
      no-close-on-backdrop
      @ok="deactivateUsers"
    >
      <p>
        The following users will be deactivated
      </p>
      <div class="user-list">
        <div class="user-list__item" v-for="user in usersToDeactivate">
          <div>
            {{ user.fullName }}
          </div>
          <div>
            {{ user.emailAddress }}
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import MainChart from '@/views/charts/MainChart'
import { get } from 'lodash'

export default {
  name: 'users',
  components: {
    MainChart
  },
  computed: {
    ...mapGetters({
      userCurrentContext: 'userCurrentContext',
      users: 'getUser',
      usersInSystem: 'getUserRecordCount',
      userMemberships: 'viewUsersMembershipsSuccess',
      organizations: 'getAllOrganizations',
      stateOptions: 'getStateAndAbbrev'
    }),
    tableItems () {
      const tableItems = this.users.map((user) => {
        if (!user.isRemoved) {
          return user
        }

        return {
          ...user,
          active: 'deactivated'
        }
      })
      return tableItems
    },
    areThereFilters () {
      return this.filter.nameText ||
        this.filter.isCseitTrained ||
        this.filter.isActive ||
        this.filter.userRole ||
        this.filter.primaryOrg ||
        this.filter.userState
    },
    activeUserLength () {
      return this.filteredItems.filter((user) => user.active === true).length
    },
    isSuperAdmin () {
      return this.$auth.user()
    },
    tableFields () {
      const fields = [
        {
          key: 'fullName',
          label: 'Full Name',
          sortable: true
        },
        {
          key: 'emailAddress',
          label: 'Email Address',
          sortable: true
        },
        {
          key: 'isCseitTrained',
          label: 'CSE-IT Trained?',
          sortable: true
        },
        {
          key: 'active',
          label: 'Active',
          sortable: true
        },
        {
          key: 'role',
          label: 'Role',
          sortable: true
        },
        {
          key: 'primaryOrganization.mailingStateAbbreviation',
          label: 'State',
          sortable: true
        },
        {
          key: 'primaryOrganization',
          label: 'Primary Organization',
          sortable: true
        }
      ]

      if (this.isSuperAdmin && this.isDeactivateUsersModeOn) {
        fields.unshift({
          key: 'isSelectedToDeactivate',
          label: '',
          sortable: false,
          thStyle: { width: '32px' }
        })
      }

      return fields
    },
    usersToDeactivate () {
      return this.tableItems.filter((item) => item.isSelectedToDeactivate)
    }
  },
  data: function () {
    return {
      spinnerColor: '#489AAC',
      spinnerSize: '50px',
      finishedLoading: false,
      modalInfo: { title: '', content: '' },
      selected: 'Month',
      currentPage: 1,
      totalRows: 0,
      filteredItems: [],
      isCseitTrained: null,
      isActive: null,
      userRole: null,
      userState: null,
      primaryOrg: null,
      userMembershipMap: {},
      organizationOptions: [],
      tableKey: 0,
      filter: {
        nameText: sessionStorage.getItem('userSearchFilter') || '',
        isCseitTrained: null,
        isActive: null,
        userRole: null,
        userState: null,
        primaryOrg: null
      },
      sortBy: 'timestamp',
      sortDesc: true,
      sortDirection: 'desc',
      isDeactivateUsersModeOn: false,
      isDeactivateUsersModalVisible: false
    }
  },
  watch: {
    userMemberships: {
      handler (newValue) {
        if (newValue && newValue.length) {
          for (const member of newValue) {
            const muser = member && member.muser
            if (!muser) {
              continue
            }

            const userId = muser.id || muser
            if (!this.userMembershipMap[userId]) {
              this.userMembershipMap[userId] = []
            }
            this.userMembershipMap[userId].push(member)
          }

          this.tableKey++
        }
      },
      deep: true
    },
    organizations (newValue) {
      if (newValue) {
        this.organizationOptions = newValue.map((org) => {
          return {
            value: org.id,
            text: org.title
          }
        })

        this.organizationOptions.sort((a, b) => a.text.localeCompare(b.text))
      }
    }
  },
  created: function () {
    this.searchUsers()
    this.$store.dispatch('getOrganizations', {})
    this.$store.dispatch('getUsersMembershipRecords', {
      populate: 'muser, morganization'
    })
  },
  methods: {
    getUserRole (user, shouldFormat = false) {
      if (!user || user.isRemoved) {
        return shouldFormat ? '' : ['']
      }

      const memberships = this.userMembershipMap[user.id]
      const userMember = memberships && memberships.length
        ? memberships.filter((member) => {
            let memberOrg = member.morganization
            let primaryOrg = user.primaryOrganization

            if (!memberOrg || !primaryOrg) {
              return false
            }

            memberOrg = memberOrg.id || memberOrg
            primaryOrg = primaryOrg.id || primaryOrg

            return parseInt(memberOrg) === parseInt(primaryOrg)
          })[0]
        : null

      let userRoles = []
      if (userMember) {
        if (userMember.isOrgAdmin) {
          userRoles.push('admin')
        }

        if (userMember.isManager) {
          userRoles.push('manager')
        }
      }
      userRoles.push('user')

      if (shouldFormat) {
        userRoles = userRoles.map((role) => {
          const firstChar = role.charAt(0)
          const restOfStr = role.slice(1)
          return firstChar.toUpperCase() + restOfStr
        }).join(', ')
      }
      return userRoles
    },
    searchUsers () {
      var params = { orgId: this.userCurrentContext.organization.id, isRemoved: false }

      this.$store.dispatch('getUserRecordCount', params)
      this.$store.dispatch('getUsers', params).then(response => {
        this.finishedLoading = true
        this.totalRows = this.users.length
      })
    },
    searchFilter (originalRecord) {
      let foundMatch = false
      let foundIsCseitTrained = true
      let founisActive = true
      let founisAadmin = true
      let foundUserRole = true
      let foundUserState = true
      let foundPrimaryOrg = true

      const stringSearches = [ 'fullName', 'emailAddress', 'active', 'primaryOrganization.title', 'isRemoved', 'isCseitTrained', 'primaryOrganization.mailingStateAbbreviation' ]
      if (this.filter.isActive !== null) {
        founisActive = this.filter.isActive === (originalRecord['active'] ? 'true' : 'false') && !originalRecord['isRemoved']
      }

      if (this.filter.isCseitTrained !== null) {
        foundIsCseitTrained = this.filter.isCseitTrained === (originalRecord['isCseitTrained'] ? 'true' : 'false')
      }

      if (this.filter.isActive === 'deactivated') {
        founisActive = originalRecord['isRemoved']
      }

      if (this.filter.userRole !== null) {
        const userRoles = this.getUserRole(originalRecord)
        foundUserRole = userRoles.includes(this.filter.userRole)
      }

      if (this.filter.userState !== null) {
        foundUserState = this.filter.userState === originalRecord.primaryOrganization.mailingStateAbbreviation
      }

      if (this.filter.primaryOrg !== null) {
        foundPrimaryOrg = this.filter.primaryOrg === originalRecord.primaryOrganization.id
      }

      if (this.filter.nameText === null) {
        return founisActive && founisAadmin && foundUserRole && foundPrimaryOrg && foundIsCseitTrained && foundUserState
      }

      let filter = this.filter.nameText.toLowerCase()
      _.forEach(stringSearches, element => {
        let field = get(originalRecord, element)
        if (_.isString(field) && field !== '') {
          field = field.toLowerCase()
          if (field.indexOf(filter) >= 0) {
            foundMatch = true
          }
        }
      })

      return foundMatch && founisActive && founisAadmin && foundUserRole && foundPrimaryOrg && foundIsCseitTrained && foundUserState
    },
    resetFilters () {
      this.isActive = null
      this.userRole = null
      this.primaryOrg = null
      this.isCseitTrained = null
      this.userState = null
      this.filter.isActive = null
      this.filter.isCseitTrained = null
      this.filter.userRole = null
      this.filter.primaryOrg = null
      this.filter.userState = null
    },
    goUser (item) {
      if (item) {
        const path = '/admin/users/' + item
        this.$router.push({ path: path })
      }
    },
    addUser (item) {
      this.$router.push({ path: '/admin/users/add' })
    },
    toggleDeactiveUsersModeOn () {
      this.isDeactivateUsersModeOn = true
    },
    toggleDeactiveUsersModeOff () {
      this.isDeactivateUsersModeOn = false
    },
    showDeactivateUsersModal () {
      this.isDeactivateUsersModalVisible = true
    },
    cancelDeactivateUserSelection () {
      this.usersToDeactivate.map((user) => {
        user.isSelectedToDeactivate = false
      })
      this.toggleDeactiveUsersModeOff()
    },
    closeDeactivateUsersModal () {
      this.isDeactivateUsersModalVisible = false
      this.toggleDeactiveUsersModeOff()
    },
    deactivateUsers () {
      const usersToDeactivate = this.usersToDeactivate.map((u) => u.id)
      this.$store.dispatch('deactivateUsers', {
        userIds: usersToDeactivate
      })
      this.toggleDeactiveUsersModeOff()
    },
    variant (value) {
      let $variant
      if (value <= 25) {
        $variant = 'info'
      } else if (value > 25 && value <= 50) {
        $variant = 'success'
      } else if (value > 50 && value <= 75) {
        $variant = 'warning'
      } else if (value > 75 && value <= 100) {
        $variant = 'danger'
      }
      return $variant
    },
    flag (value) {
      return 'flag-icon flag-icon-' + value
    },
    getRowCount (items) {
      if (this.filter) {
        return this.totalRows
      }
      return items.length
    },
    onFiltered (filteredItems) {
      this.filteredItems = filteredItems
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },
    handleFilterChange (value) {
      sessionStorage.setItem('userSearchFilter', value)
    },
    clearFilter (value) {
      this.filter.nameText = ''
      sessionStorage.setItem('userSearchFilter', '')
    },
    updateSearchResults () {
      this.filter.isActive = this.isActive
      this.filter.isCseitTrained = this.isCseitTrained
      this.filter.userRole = this.userRole
      this.filter.primaryOrg = this.primaryOrg
      this.filter.userState = this.userState
    }
  }
}
</script>

<style lang="scss" scoped>
.users-table__footer {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.user-list__item {
  padding: 10px 0;
  border-bottom: 1px solid gray;
}
</style>

<style lang="scss">
.users-table__checkbox.custom-checkbox .custom-control-label::before {
  border: 2px solid #20a8d8;
}

.users-table__checkbox.custom-checkbox .custom-control-input:checked ~ {
  .custom-control-label::after {
    background-image: none;
  }

  .custom-control-label::before {
    background-color: gray;
  }
}

</style>


// WEBPACK FOOTER //
// src/views/t1/Admin/Users.vue